export const selectIsCheckingPayUStatus = (state) => {
    return state.shop.payu.isChecking;
};

export const selectPayUOrderStatus = (state) => {
    return state.shop.payu.orderStatus;
};
